<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm" :rules="searchRules">
      <el-form-item label="项目名称:" clearable prop="projectName">
        <el-input v-model.trim="searchForm.projectName" maxlength="30" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="原合同编号:" prop="oldContractNum">
        <el-input v-model.trim="searchForm.oldContractNum" maxlength="20" placeholder="请输入原合同编号" />
      </el-form-item>
      <el-form-item label="合同编号:" clearable prop="newContractNum">
        <el-input v-model.trim="searchForm.newContractNum" maxlength="20" placeholder="请输入合同编号" />
      </el-form-item>

      <el-form-item label="代理商名称:" prop="orderUnitName">
        <el-input v-model.trim="searchForm.orderUnitName" maxlength="30" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="商务:" prop="assistantName">
        <el-input v-model.trim="searchForm.assistantName" maxlength="20" placeholder="请输入商务名称" />
      </el-form-item>
      <el-form-item label="合同类型:">
        <el-select v-model="searchForm.contractType" placeholder="请选择合同类型">
          <el-option v-for="item in selectList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item label="外销:" prop="salesPersonName">
        <el-input v-model.trim="searchForm.salesPersonName" maxlength="20" placeholder="请输入外销名称" />
      </el-form-item>
      <el-form-item label="合同时间:">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerStartOptions"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerEndOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="部门:" prop="salesPersonDeptName">
        <el-input v-model.trim="searchForm.salesPersonDeptName" maxlength="20" placeholder="请输入部门名称" />
      </el-form-item>
      <el-form-item label="区域:" prop="salesArea">
        <el-input v-model.trim="searchForm.salesArea" maxlength="20" placeholder="请输入区域名称" />
      </el-form-item>
      <el-form-item label="退换货原因:">
        <el-select v-model="searchForm.reasonType" placeholder="请选择退还原因">
          <el-option v-for="item in reasonList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="searchCilck">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="rContractId" label="操作" width="90" align="left">
          <template slot-scope="scope">
            <el-button type="text" @click="handel(scope.row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" width="220" />
        <el-table-column prop="oldContractNum" label="原合同编号" align="left" width="150" />
        <el-table-column prop="newContractNum" label="合同编号" align="left" width="150" />
        <el-table-column prop="orderUnitName" label="代理商名称" align="left" width="150" />
        <el-table-column prop="contractType" label="合同类型" align="left" width="150" />
        <el-table-column prop="reasonType" label="退换货原因" align="left" width="150">
          <!-- D8：落库值（如“产品发运错误”）经 displayReasonType 映射后再展示 -->
          <template slot-scope="scope">
            {{ displayReasonType(scope.row.reasonType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderType" label="订单分类" align="left" width="150" />
        <el-table-column prop="salesArea" label="区域" align="left" width="150" />
        <el-table-column prop="salesPersonName" label="外销" align="left" width="150" />
        <el-table-column prop="assistantName" label="商务" align="left" width="90" />
        <el-table-column label="合同时间" align="left" width="150">
          <template slot-scope="scope">
            {{ scope.row.createdTime }}
          </template>
        </el-table-column>
        <el-table-column label="合同附件" align="left" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="checkFile(scope.row)">
              查看附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-id="num" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { overseasExOrderTodolist } from '@/API';
import contractAttachment from '../../returnExchange/Chief/commom/internationalfileDialog.vue';
import { displayReasonType } from '@/constant';
export default {
  data () {
    return {
      pickerEndOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startTime) {
            let date = new Date(this.searchForm.startTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pickerStartOptions: {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime();
          } else {
            return false;
          }
        }
      },
      searchForm: {
        projectName: '',
        oldContractNum: '',
        newContractNum: '',
        orderUnitName: '',
        assistantName: '',
        contractType: '',
        salesPersonName: '',
        startTime: '',
        endTime: '',
        salesPersonDeptName: '',
        salesArea: '', // 退换货原因
        reasonType: '',
        contractStatus: 3
      },
      contractReturnType: '', // 处理退货合同的路由参数
      contractVisible: false,
      tableLoading: false,
      num: '',
      tableData: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      selectList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '换货合同',
          label: '换货合同'
        },
        {
          value: '价外费用合同',
          label: '价外费用合同'
        },
        {
          value: '退货合同(已发货)',
          label: '退货合同(已发货)'
        },
        {
          value: '退货合同(未发货)',
          label: '退货合同(未发货)'
        }
      ],
      reasonList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '市场销售原因',
          label: '市场销售原因'
        },
        {
          value: '产品缺货或停产',
          label: '产品缺货或停产'
        },
        {
          value: '其他特殊原因',
          label: '其他特殊原因'
        },
        {
          value: '其他特殊原因(税率)',
          label: '其他特殊原因(税率)'
        },
        {
          value: '齐套不提货撤单',
          label: '齐套不提货撤单'
        },
        {
          value: '产品功能问题',
          label: '产品功能问题'
        }
      ],
      searchRules: {
        projectName: [
          { required: false, message: '请输入项目名称', trigger: 'blur' },
          { min: 0, max: 30, message: '最大长度不能超过30个字符', trigger: 'blur' }
        ],
        oldContractNum: [
          { required: false, message: '请输入原合同编号', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        newContractNum: [
          { required: false, message: '请输入合同编号', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        orderUnitName: [
          { required: false, message: '请输入代理商名称', trigger: 'blur' },
          { min: 0, max: 30, message: '最大长度不能超过30个字符', trigger: 'blur' }
        ],
        assistantName: [
          { required: false, message: '请输入商务', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        salesArea: [
          { required: false, message: '请输入区域', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        salesPersonDeptName: [
          { required: false, message: '请输入部门', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        salesPersonName: [
          { required: false, message: '请输入外销', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    contractAttachment
  },
  computed: {

  },
  methods: {
    // D8：退换货原因展示名映射（落库值保持不变，仅展示层生效）
    displayReasonType,
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },

    searchCilck () {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.page.currentPage = 1;
          this.doSearch();
        } else {
          return false;
        }
      });
    },

    resetForm () {
      this.searchForm = {
        projectName: '',
        oldContractNum: '',
        newContractNum: '',
        orderUnitName: '',
        assistantName: '',
        contractType: '',
        salesPersonName: '',
        startTime: '',
        endTime: '',
        salesPersonDeptName: '',
        salesArea: '', // 退换货原因
        reasonType: '',
        contractStatus: 3
      };
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.doSearch();
    },

    doSearch () {
      this.tableLoading = true;
      let parmas = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      overseasExOrderTodolist(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {

      });
      this.tableLoading = false;
    },
    handel (row) {
      this.$router.push({
        name: 'interOrderReturnExchange',
        query: {
          contractType: row.contractType,
          contractId: row.id
        }
      });
    },
    checkFile (row) {
      this.num = row.id;
      this.contractVisible = true;
    }
  },
  mounted () {
    this.doSearch();
  },
  activated () {

  },
  destroyed () {
  }
};
</script>
<style lang="scss"></style>
